<template>
    <div class="narrowcol">
        <slot />
    </div>
</template>
